const DOTS_GAP = 45;

const dotTemplate = document.createElement('div');
dotTemplate.classList.add('Dots-dot');
dotTemplate.style.position = 'absolute';

function generateDots() {
  document.querySelectorAll('.Dots').forEach(container => {
    const rect = container.getBoundingClientRect();

    if (rect.top > window.innerHeight || rect.bottom < 0) return;

    const numX = rect.width / DOTS_GAP;
    const numY = rect.height / DOTS_GAP;

    const avoidRects = Array.from(container.querySelectorAll('.Dots-avoid'))
      .map(el => el.getBoundingClientRect());

    for (let i = Math.ceil(numX / -2); i < numX / 2; i++) {
      for (let j = Math.ceil(numY / -2); j < numY / 2; j++) {
        const dotLeft = rect.left + rect.width / 2 + (i * DOTS_GAP);
        const dotTop = rect.top + rect.height / 2 + (j * DOTS_GAP);

        if (dotTop > window.innerHeight) continue;

        const className = `dot-${i}-${j}`;
        let dot = container.querySelector(`.${className}`);

        if (! dot) {
          dot = dotTemplate.cloneNode(true);
          dot.classList.add(className);
          dot.style.left = `calc(50% + ${i * DOTS_GAP}px)`;
          dot.style.top = `calc(50% + ${j * DOTS_GAP}px)`;
          dot.style.width = dot.style.height = Math.ceil(Math.random() * 10) + 'px';
          container.appendChild(dot);
        }

        if (avoidRects.length) {
          dot.style.visibility = '';
          avoidRects.forEach(avoidRect => {
            if (dotTop > avoidRect.top && dotTop < avoidRect.bottom && dotLeft > avoidRect.left && dotLeft < avoidRect.right) {
              dot.style.visibility = 'hidden';
            }
          });
        }

        if (dot.style.animationPlayState !== 'running') {
          dot.style.animationPlayState = 'running';
          dot.style.animationDelay = (Math.random() * .5) + 's';
        }
      }
    }
  });
}

// See https://developer.mozilla.org/en-US/docs/Web/API/Document/scroll_event
let ticking = false;

function tick() {
  if (ticking) return;
  ticking = true;
  window.requestAnimationFrame(() => {
    generateDots();
    ticking = false;
  });
}

window.addEventListener('scroll', tick);
window.addEventListener('resize', tick);
tick();
